import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'

import { type AnalyticsEvent } from '@salsita-ai/platform-project-sdk/domain'

import { analyticsService } from '../../systems/analytics'
import { configuratorInterface } from '../../systems/configurator-interface'
import { getQuoteId, getQuoteLineId, setQuoteId, setQuoteLineId } from '../../systems/metalworks-api'

export const useCloneConfiguration = (analyticsEvent?: AnalyticsEvent) => {
  const { storeSystem, configurationId } = configuratorInterface.useDomain()

  const authenticatedClient = configuratorInterface.useAuthenticatedClient()
  const routing = configuratorInterface.useConfiguratorRouting()

  const cloneAndStart = useCallback(async () => {
    if (analyticsEvent) {
      analyticsService.push(analyticsEvent)
    }

    const { accessToken, configurationId: newConfigurationId } = await authenticatedClient.createConfiguration({
      rootEntityType: storeSystem.stateSlices.committed.value.state.rootEntityType,
      data: storeSystem.stateSlices.committed.value.state.entities.slice(0),
    })

    const quoteId = getQuoteId(configurationId)

    if (quoteId != null) {
      setQuoteId(newConfigurationId, quoteId)
    }

    const quoteLineId = getQuoteLineId(configurationId)

    if (quoteLineId != null) {
      setQuoteLineId(newConfigurationId, quoteLineId)
    }

    routing.goToConfigurationDetail(newConfigurationId, accessToken)
  }, [configurationId, authenticatedClient, routing, storeSystem, analyticsEvent])

  const { isPending, mutate } = useMutation({
    mutationKey: ['cloneAndStart'],
    mutationFn: cloneAndStart,
  })

  return {
    isPending,
    cloneAndStart: mutate,
  }
}
